import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const modalContent = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
  width: '100%',
});

export const modalHeader = style({
  textAlign: 'center',
  marginBottom: space.s16,
});

export const modalTitle = style({
  margin: `0 0 ${space.s8} 0`,
  fontSize: '20px',
  fontWeight: '600',
});

export const modalDescription = style({
  color: themeVars.container.foreground.secondary,
  margin: 0,
});

export const modalActions = style({
  display: 'flex',
  gap: space.s12,
});

export const modalButton = style({
  flex: 1,
});
